module.exports = __webpack_public_path__ + "img/20220201120709345v10.de29ff77.png";